import type { LoyaltyProfile } from "@app/types/loyalty";
import type {
  CreditCard,
  NapiUser,
  NapiRedeemableAmounts,
  UserBillingAddress
} from "@app/types/napi-types";
import type { NapiV2PurchaseDetails } from "@app/types/napi-v2-purchase-types";

export const TripCancelStatus = {
  success: "success",
  pending: "pending",
  failed: "failed",
  notCancellable: "notCancellable",
  cancellable: "cancellable",
  denied: "denied"
} as const;

export interface AccountReduxState {
  user: NapiUser;
  loyalty_profile?: LoyaltyProfile;
  credit_cards: CreditCard[];
  redeemable_amounts: NapiRedeemableAmounts;
  purchase: NapiV2PurchaseDetails;
  user_billing_address: UserBillingAddress | null;
}

export type PurchaseAuth =
  | PurchaseAuthUser
  | PurchaseAuthUuid
  | PurchaseAuthSession;

interface PurchaseAuthUser {
  kind: "user";
  user: NapiUser;
}

interface PurchaseAuthUuid {
  kind: "purchase_uuid";
  purchase_uuid: string;
}

interface PurchaseAuthSession {
  kind: "session";
  purchase_id: number;
}
